module.exports = __webpack_public_path__ + "img/icon_map_61_off_110.0048d0e9.png";